// 488991: отключен баннер
// import $ from 'jquery';
// import { getCookie } from '../_main/common';

// function setCookie(name, value, hours) {
// 	let date = new Date();
// 	date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
// 	const expires = "expires=" + date.toUTCString();
// 	document.cookie = name + "=" + value + ";" + expires + ";path=/";
// }

// document.addEventListener('DOMContentLoaded', () => {
// 	if ($(window).width() <= 576 && !getCookie('applink')) {
// 		$('.header .app-link').fadeIn(0);
// 	}
// 	$(document).on('click', '.app-link .js-app-close', function () {
// 		$('.header .app-link').fadeOut(0);
// 		setCookie('applink', 'true', 1);
// 	});

// 	$(document).on('click', '.app-link .download-link', function () {
// 		$('.header .app-link').fadeOut(0);
// 		setCookie('applink', 'true', 1);
// 	});
// })
